import { render, staticRenderFns } from "./CharacterScene.vue?vue&type=template&id=07b251e4&scoped=true&"
import script from "./CharacterScene.vue?vue&type=script&lang=js&"
export * from "./CharacterScene.vue?vue&type=script&lang=js&"
import style0 from "./CharacterScene.vue?vue&type=style&index=0&id=07b251e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b251e4",
  null
  
)

export default component.exports